import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'

import {
  TwitterShareButton,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  FacebookShareButton,
  FacebookIcon
} from 'react-share'

import * as ProfileReducer from '../../reducers/profile'
import * as ClubsReducer from '../../reducers/clubs'
import * as AnalyticsReducer from '../../reducers/analytics'
import * as AuthReducer from '../../reducers/auth'

import colors from '@fe/ui/colors'
import Spinner from '@fe/ui/Spinner'

// Material UI things
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'
import Button from '@material-ui/core/Button'

import {
  ArrowRight
} from '@material-ui/icons'

import { getStaticBackground, getClubImage, RETURN_PATH } from '../../config'

import ProfileImage from '../../components/profile/ProfileImage'
import { useElementWidth } from '../Game/Stats'
import { Speedometer } from '../../components/Charts'
import PlayedMap from './PlayedMap'

import { withStyles } from '@material-ui/core/styles'
import { loader } from 'graphql.macro'
import { graphql } from 'react-apollo'
import NoSuchUser from '@fe/ui/errors/NoSuchUser'
const frontpageDataQuery = loader('./frontpageData.gql')

const homeStyles = theme => ({
  widthCalc: {
    width: '100vw',
    [theme.breakpoints.up('md')]: {
      width: 'calc(100vw - 240px)'
    }
  },
  maxWidth: {
    maxWidth: 1280
  }
})

const TopBottomTexter = ({ topText, bottomText }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '16vh', justifyContent: 'center', marginLeft: '1vw', marginRight: '1vw' }}>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', flex: 1 }}>
        {topText}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', flex: 1 }}>
        {bottomText}
      </div>
    </div>
  )
}

const GamesTotalStats = ({ games, overlay = false }) => {
  const totalHoles = React.useMemo(() => _.flow(
    _.map('toCh'),
    _.map(_.size),
    _.sum
  )(games), [games])
  const totalShots = React.useMemo(() => _.flow(
    _.map('gameShots'),
    _.sum
  )(games), [games])
  const totalPoints = React.useMemo(() => _.flow(
    _.map('gamePoints'),
    _.sum
  )(games), [games])

  const topTextStyle = React.useMemo(() => {
    if (overlay) {
      return ({
        textAlign: 'center',
        color: colors.white,
        textShadow: '1px 1px 1px black'
      })
    }
    return ({
      textAlign: 'center',
      color: colors.primaryDarkGreen
    })
  }, [overlay])

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', marginRight: '-1vw' }}>
      <TopBottomTexter
        topText={<Typography variant='h4' style={topTextStyle}>{totalHoles}</Typography>}
        bottomText={<Typography style={{ textAlign: 'center' }}>Holes Played</Typography>}
      />

      <TopBottomTexter
        topText={<Typography variant='h4' style={topTextStyle}>{totalShots}</Typography>}
        bottomText={<Typography style={{ textAlign: 'center' }}>Shots</Typography>}
      />

      <TopBottomTexter
        topText={<Typography variant='h4' style={topTextStyle}>{totalPoints}</Typography>}
        bottomText={<Typography style={{ textAlign: 'center' }}>Points</Typography>}
      />
    </div>
  )
}

const ProfileBar = ({ profile, games, homeClub, className }) => {
  return (
    <div
      style={{
        height: '16vh',
        position: 'relative',
        top: '-8vh',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: 'auto'
      }}
      className={className}
    >
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around' }}>
        <ProfileImage profile={profile} backgroundColor={colors.white} textColor={colors.primaryDarkGreen} rim size='14vh' />

        <TopBottomTexter
          topText={<Typography variant='h4' style={{ color: colors.white, textShadow: '1px 1px 1px black' }}>{_.get('name', profile)}</Typography>}
          bottomText={<div><Typography>{_.get('name', homeClub)}</Typography><Typography>{`HCP ${_.get('handicap', profile)}`}</Typography></div>}
        />

      </div>
      <Hidden smDown>
        <GamesTotalStats overlay games={games} profile={profile} />
      </Hidden>

    </div>
  )
}

const ShareButtonsBase = ({ profile, userHome, ...props }) => {
  const shareUrl = React.useMemo(() => `${RETURN_PATH}/u/${_.get('handle', profile)}`, [profile])
  const shareOpen = React.useCallback((label) => async () => props.shareOpen(label), [props.shareOpen])
  const shareClose = React.useCallback((label) => () => props.shareClose(label), [props.shareClose])

  if (!userHome) {
    return false
  }

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
      <TwitterShareButton onShareWindowClose={shareClose('twitter')} beforeOnClick={shareOpen('twitter')} style={{ margin: 10 }} url={shareUrl}>
        <TwitterIcon size={42} round />
      </TwitterShareButton>

      <FacebookShareButton onShareWindowClose={shareClose('faebook')} beforeOnClick={shareOpen('facebook')} quote='Check out my profile on my.glfr!' hashtag='#iamaGLFR' style={{ margin: 10 }} url={shareUrl}>
        <FacebookIcon size={42} round />
      </FacebookShareButton>

      <FacebookMessengerShareButton onShareWindowClose={shareClose('facebook-messenger')} beforeOnClick={shareOpen('facebook-messenger')} style={{ margin: 10 }} appId='1020695051398914' url={shareUrl}>
        <FacebookMessengerIcon size={42} round />
      </FacebookMessengerShareButton>
    </div>
  )
}

const ShareButtons = _.compose(
  connect(
    (s, p) => ({}),
    (d, p) => ({
      shareOpen: (label) => d(AnalyticsReducer.actions.shareOpen({ label })),
      shareClose: (label) => d(AnalyticsReducer.actions.shareClose({ label }))
    })
  )
)(ShareButtonsBase)

const getRandInt = (max) => {
  return Math.floor(Math.random() * max)
}

const HomePage = ({ userHandle, classes, data, profileLoadError, storeProfile, getHomeClub, clubs, history, location, loggedIn, ...otherProps }) => {
  React.useEffect(() => {
    otherProps.getClubs()
    otherProps.loadProfile()
  }, [otherProps.getClubs, otherProps.loadProfile])

  React.useEffect(() => {
    if (profileLoadError && location.pathname === '/') {
      history.push('/login')
    }
  }, [history, location, profileLoadError])

  const titles = [
    'Checking Scorecards',
    'Finding Fairway Hits',
    'Looking for lost balls',
    'Counting Putts',
    'Calculating Bogies and Birdies',
    'Ignoring Bunker Shots',
    'Setting up stats'
  ]
  const [index, setIndex] = React.useState(getRandInt(titles.length))

  React.useEffect(() => {
    if (_.isEmpty(clubs)) {
      const interval = setInterval(() => {
        setIndex(getRandInt(titles.length))
      }, 1500)
      return () => {
        clearInterval(interval)
      }
    }
  })

  const userHome = React.useMemo(() => {
    const storeHandle = _.get('handle', storeProfile)
    return (storeHandle === userHandle) || !userHandle
  }, [storeProfile, userHandle])

  const profile = React.useMemo(() => {
    const foreignProfile = _.get('getProfileByHandle', data)
    if (userHome) {
      return storeProfile
    }
    return foreignProfile
  }, [storeProfile, data])

  const homeClub = React.useMemo(() => {
    const clubId = _.get('clubId', profile) || _.get('club_id', profile)
    const homeClub = getHomeClub(clubId)
    return homeClub
  }, [profile, clubs])

  const games = React.useMemo(() => {
    return _.get('getGames', data)
  }, [data])

  const playedClubs = React.useMemo(() => _.flow(_.groupBy('clubId'), _.mapValues(_.size))(games), [games])
  const totalHoles = React.useMemo(() => _.flow(_.map('toCh'), _.map(_.size), _.sum)(games), [games])
  const totalGir = React.useMemo(() => _.flow(_.map('greensInRegulation'), _.sum)(games), [games])
  const totalFir = React.useMemo(() => _.flow(_.map('fairwaysInRegulation'), _.sum)(games), [games])
  const totalScramblings = React.useMemo(() => _.flow(_.map('scramblings'), _.sum)(games), [games])
  const totalHolesWithPutts = _.flow(_.flatMap('putts'), _.filter(v => Boolean(v)), _.size)(games)
  const total2Putts = _.flow(_.flatMap('putts'), _.filter(v => Boolean(v) && v <= 2), _.size)(games)

  const bannerImage = React.useMemo(() => {
    const galleryImage = _.flow(
      _.get('gallery_file_names'),
      _.first
    )(homeClub)

    if (galleryImage) {
      return `url(${getClubImage(galleryImage)})`
    }
    return `url(${getStaticBackground()})`
  }, [homeClub])

  const [fBig, bigWidth] = useElementWidth()
  const bigSpeedometerWidth = _.min([200, bigWidth / 6])
  const bigTextSize = _.toInteger(_.min([14, bigWidth * 0.025]))

  const [fSmall, smallWidth] = useElementWidth()
  const smallSpeedometerWidth = _.min([200, smallWidth / 3])
  const smallTextSize = _.toInteger(_.min([14, smallWidth * 0.025]))

  if (_.get('error', data)) {
    return (
      <NoSuchUser loggedIn={loggedIn} />
    )
  }

  if (_.get('loading', data) || (!_.isEmpty(_.get('getGames', data)) && _.isEmpty(games)) || _.isEmpty(clubs)) {
    return (
      <Spinner title='Loading your profile' subtitle={titles[index]} />
    )
  }
  return (
    <div className='outer-container'>
      <div style={{ height: '32vh', width: '100%', backgroundImage: bannerImage, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <ShareButtons userHome={userHome} profile={profile} />
      </div>
      <div className='container-1280'>

        <ProfileBar games={games} profile={profile} homeClub={homeClub} />

        <Hidden mdUp>
          <GamesTotalStats games={games} profile={profile} />
        </Hidden>

        <Hidden mdDown>
          <div
            ref={fBig}
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              margin: 'auto'
            }}
          >
            <Speedometer width={bigSpeedometerWidth} label='Fairways in regulation' total={totalHoles || 0} value={totalFir || 1} fatLabelText={bigTextSize} />
            <Speedometer width={bigSpeedometerWidth} label='Greens in regulation' total={totalHoles || 0} value={totalGir || 1} fatLabelText={bigTextSize} />
            <Speedometer width={bigSpeedometerWidth} label='Scrambling' total={totalHoles || 0} value={totalScramblings || 1} fatLabelText={bigTextSize} />
            <Speedometer width={bigSpeedometerWidth} label='Two-putts or better' total={totalHolesWithPutts || 0} value={total2Putts || 1} fatLabelText={bigTextSize} />
          </div>
        </Hidden>

        <Hidden lgUp>
          <div
            ref={fSmall}
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              margin: 'auto'
            }}
          >
            <Speedometer
              width={smallSpeedometerWidth}
              label='Fairways in regulation'
              total={totalHoles || 0}
              value={totalFir || 1}
              fatLabelText={smallTextSize}
            />
            <Speedometer
              width={smallSpeedometerWidth}
              label='Greens in regulation'
              total={totalHoles || 0}
              value={totalGir || 1}
              fatLabelText={smallTextSize}
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              margin: 'auto'
            }}
          >
            <Speedometer
              width={smallSpeedometerWidth}
              label='Scrambling'
              total={totalHoles || 0}
              value={totalScramblings || 1}
              fatLabelText={smallTextSize}
            />
            <Speedometer
              width={smallSpeedometerWidth}
              label='Two-putts or better'
              total={totalHolesWithPutts || 0}
              value={total2Putts || 1}
              fatLabelText={smallTextSize}
            />
          </div>
        </Hidden>

        {!userHome && (
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', paddingRight: 10 }}>
            <NavLink to={`/u/${userHandle}/games`}>
              <Button endIcon={<ArrowRight />}>
                <Typography variant='h6' style={{ color: colors.primaryDarkGreen }}>
                  {`View ${_.get('name', profile)}s games`}
                </Typography>
              </Button>
            </NavLink>
          </div>
        )}

      </div>
      <PlayedMap playedClubs={playedClubs} homeClub={homeClub} clubs={clubs} classes={classes} />
    </div>
  )
}

export default _.compose(
  withStyles(homeStyles),
  connect(
    (s, ownProps) => {
      const profileLoadError = ProfileReducer.selectors.loadError(s)
      const storeProfile = ProfileReducer.selectors.getProfile(s)
      const clubs = ClubsReducer.selectors.activeClubs(s)
      const paramHandle = _.get('match.params.userHandle', ownProps)
      const storeHandle = _.get('handle', storeProfile)
      const userHandle = !paramHandle || (paramHandle === storeHandle)
        ? storeHandle
        : paramHandle
      const loggedIn = AuthReducer.selectors.loggedIn(s)
      return {
        profileLoadError,
        storeProfile,
        getHomeClub: (clubId) => ClubsReducer.selectors.clubById(clubId)(s),
        currentUserHandle: ProfileReducer.selectors.getProfileHandle(s),
        saveWaiting: ProfileReducer.selectors.saveWaiting(s),
        userHandle,
        clubs,
        loggedIn
      }
    },
    (d, ownProps) => {
      return {
        getClubs: () => d(ClubsReducer.actions.clubsRequest()),
        loadProfile: () => d(ProfileReducer.actions.loadRequest(Date.now()))
      }
    }
  ),
  graphql(frontpageDataQuery,
    {
      skip: props => !props.userHandle,
      options: props => ({
        errorPolicy: 'none',
        variables: {
          handle: props.userHandle
        }
      })
    })
)(HomePage)
